var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-4"},[_c('Button',{attrs:{"text":"","color":"error","loading":_vm.CartItem.deleteLoading},on:{"click":_vm.CartItem.deleteItem}},[_vm._v(" "+_vm._s(_vm._f("lang")('Eliminar'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }